// Aquí está el slice de usuario
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoEmpresa: null,
  failureEmpresa: false,
  errorEmpresa: null,
  isLoadingEmpresa: false,
};

const empresaSlice = createSlice({
  name: "empresa",
  initialState,
  reducers: {
    empresaSuccess: (state, action) => {
      state.infoEmpresa = action.payload.infoEmpresa;
      state.failureEmpresa = false;
      state.isLoadingEmpresa = false;
    },
    empresaFailure: (state, action) => {
      state.failureEmpresa = true;
      state.isLoadingEmpresa = false;
      state.errorEmpresa = action.payload; // mensaje de errorEmpresa
    },
    empresaReset: (state) => {
      state.infoEmpresa = null;
      state.failureEmpresa = false;
      state.errorEmpresa = null;
      state.isLoadingEmpresa = false;
    },
    setInfoEmpresa: (state, action) => {
      state.infoEmpresa = action.payload;
    }
  },
});


export const {
  empresaSuccess,
  empresaFailure,
  empresaReset,
  setInfoEmpresa,
} = empresaSlice.actions;
export default empresaSlice.reducer;
